import { CustomCategoryGoal } from '@map/types';
import { Reducer } from 'redux';

const initialState = {} as Record<string, CustomCategoryGoal>;
type State = typeof initialState;

const CUSTOM_CATEGORY_GOALS_FETCHED = 'CUSTOM_CATEGORY_GOALS_FETCHED';

export const actionCreators = {
  customCategoryGoalsFetched: (data: State) =>
    ({ type: CUSTOM_CATEGORY_GOALS_FETCHED, data }) as const,
};

type Action = ReturnType<(typeof actionCreators)[keyof typeof actionCreators]>;

const customCategoryGoals: Reducer<State, Action> = (state = initialState, action: Action) => {
  switch (action.type) {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    case CUSTOM_CATEGORY_GOALS_FETCHED:
      return action.data;
    default:
      return state;
  }
};

export default customCategoryGoals;
